export default __webpack_public_path__ + "static/media/YourHub.3e99413b.png";